
import { useToast } from "@/hooks/use-toast";
import { Listing } from "@/lib/types";
import { useState } from "react";

export const useFavorite = (property: Listing) => {
  const [isFavorite, setIsFavorite] = useState(false);
  const { toast } = useToast();

  const handleToggleFavorite = (e: React.MouseEvent) => {
    e.preventDefault();
    setIsFavorite(!isFavorite);

    toast({
      title: isFavorite ? "Removed from favorites" : "Added to favorites",
      description: isFavorite
        ? `${property.title} has been removed from your favorites`
        : `${property.title} has been added to your favorites`,
      variant: isFavorite ? "default" : "success",
    });
  };

  return { isFavorite, handleToggleFavorite };
};
